import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IExcelTemplateDTO } from 'src/app/_interfaces/uploadingTool/i-excel-templates';
import { GenericResponse, SuccessResponse } from 'src/app/_models/response.model';

@Injectable({
  providedIn: 'root'
})
export class UploadingToolService {

  constructor(private httpClient: HttpClient) { }

  excelSheetUploadQueueUrl: string = 'api/AdminExcelSheetUploadQueue';
  getExcelTemplatesUrl: string = 'api/AdminExcelSheetUploadQueue/Templates';

  uploadExcelSheet(fileTypeId, file): Observable<SuccessResponse> {
    let formData = new FormData();
    formData.append('sheetTypeId', fileTypeId);
    formData.append('sheet', file);

    return this.httpClient.post<SuccessResponse>(this.excelSheetUploadQueueUrl, formData);
  }

  getExcelTemplates(): Observable<GenericResponse<IExcelTemplateDTO[]>>{
    return this.httpClient.get<GenericResponse<IExcelTemplateDTO[]>>(this.getExcelTemplatesUrl);
  }
}
